import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { App, URLOpenListenerEvent } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";

// Pulled from https://capacitorjs.com/docs/guides/deep-links#react
// for supporting deep links
export default function DeepLinkListener() {
  const navigate = useNavigate();
  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      App.addListener("appUrlOpen", (event: URLOpenListenerEvent) => {
        const slug = new URL(event.url);
        if (slug?.pathname) {
          navigate(slug.pathname + slug.search);
        }
      });
    }
  }, []);

  return null;
}
